import request from '@/utils/request'

/**
 * 获取项目列表
 * @param param
 */
export function fetchData (userId) {
	return request({
		url: '/api/controlForm/list/' + userId,
		method: 'post',
	})
}

/**
 * 新增公告
 * @param param
 */
export function save (query) {
	return request({
		url: '/api/controlForm/save',
		method: 'post',
		data: query
	})
}

/**
 * 修改公告
 * @param param
 */
export function update (query) {
	return request({
		url: '/api/controlForm/update',
		method: 'post',
		data: query
	})
}

/**
 * 获取公告
 * @param param
 */
export function get (id) {
	return request({
		url: '/api/controlForm/get/' + id,
		method: 'get'
	})
}

/**
 * 删除公告
 * @param param
 */
export function remove (id) {
	return request({
		url: '/api/controlForm/delete/' + id,
		method: 'post'
	})
}



